import React, { FunctionComponent, useState, useRef } from "react";
import styles from "./ImageSlideshow.module.scss";
import {
  NavigateBeforeRounded,
  NavigateNextRounded,
  CloseRounded,
} from "@material-ui/icons";
import useOutsideClick from "shared/utils/useOutsideClick";

const ImageSlideshow: FunctionComponent<{
  images: string[];
  open: boolean;
  closeModal: () => void;
}> = ({ images, open, closeModal }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const dropDownRef = useRef<HTMLDivElement>(null);

  useOutsideClick(dropDownRef, () => closeModal());

  const goPrevious = () => {
    if (currentIndex <= 0) {
      setCurrentIndex(0);
      return;
    }

    setCurrentIndex(currentIndex - 1);
  };

  const goNext = () => {
    if (currentIndex >= images.length - 1) {
      setCurrentIndex(images.length - 1);
      return;
    }

    setCurrentIndex(currentIndex + 1);
  };

  return (
    <>
      {open && (
        <div className={styles.imageSlideshow}>
          <div className={styles.imageSlideshow_main}>
            <div
              className={styles.imageSlideshow_backdrop}
              onClick={closeModal}
            />

            <div className={styles.imageSlideshow_imgWrapper}>
              {images.map((image, index) => (
                <img
                  loading="lazy"
                  src={image}
                  alt={image}
                  style={{
                    display: index === currentIndex ? "initial" : "none",
                  }}
                />
              ))}
            </div>

            <button
              aria-label="close"
              className={styles.imageSlideshow_closeButton}
              onClick={closeModal}
            >
              <CloseRounded fontSize="large" />
            </button>

            {currentIndex > 0 && (
              <button
                aria-label="back"
                className={styles.imageSlideshow_prevButton}
                onClick={goPrevious}
              >
                <NavigateBeforeRounded fontSize="large" />
              </button>
            )}

            {currentIndex < images.length - 1 && (
              <button
                aria-label="next"
                className={styles.imageSlideshow_nextButton}
                onClick={goNext}
              >
                <NavigateNextRounded fontSize="large" />
              </button>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default ImageSlideshow;
